// extracted by LIB_CSS_EXTRACT_LOADER
import "./scroll-area_module.css"
export default {"root":"root-PHMnj2","viewport":"viewport-gb0rys","content":"content-NurFf1","scrollbar":"scrollbar-DRWGyJ","vertical":"vertical-JL0pek","horizontal":"horizontal-Njbt1v","thumb":"thumb-sOMmuA","corner":"corner-u_EeOP"};